import {
  OFFERS_ON_OFFER_CLICKED,
  OFFERS_RECEIVE,
  OFFERS_SET_ACTIVE,
  OFFERS_SHOW_OFFER_MENU,
} from '../constants';

const DEFAULT_STATE = {
  activeOfferSystemId: null,
  offers: [],
  showOfferMenu: false,
  onOfferClicked: null,
  helpPageUrl: null,
};

export const offers = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case OFFERS_RECEIVE:
    case OFFERS_SHOW_OFFER_MENU:
    case OFFERS_SET_ACTIVE:
    case OFFERS_ON_OFFER_CLICKED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
